import { Card, useWindowWidth } from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { MOBILE_WIDTH } from '@/constants';

import { ChannelRecordingType } from '../../types';

import { ChannelRecordingDetail } from './components/ChannelRecordingDetail/ChannelRecordingDetail';

type ChannelRecordingDetailsCardProps = {
  channelRecording: ChannelRecordingType;
  isCollapsed: boolean;
  onCollapse: () => void;
  onUpdate: (channelRecording: ChannelRecordingType) => void;
};

export function ChannelRecordingDetailCard({
  isCollapsed,
  channelRecording,
  onCollapse,
  onUpdate,
}: ChannelRecordingDetailsCardProps) {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      title={channelRecording.name}
      className="w-full text-secondary-10"
      isAccordion={isMobile}
      isCollapsable={!isMobile}
      isOpen={isOpen}
      collapseDirection="right"
      lineSeparator={true}
      isCollapsed={isCollapsed && !isMobile}
      onCollapse={onCollapse}
      onOpen={() => setIsOpen(!isOpen)}
      classes={{
        header: clsx(!isMobile && 'py-3'),
      }}
    >
      <div className="body flex flex-col gap-size-12 self-stretch">
        <ChannelRecordingDetail channelRecording={channelRecording} onUpdate={onUpdate} />
      </div>
    </Card>
  );
}
